import { render, staticRenderFns } from "./facedialog.vue?vue&type=template&id=6479c16c&scoped=true"
import script from "./facedialog.vue?vue&type=script&lang=js"
export * from "./facedialog.vue?vue&type=script&lang=js"
import style0 from "./facedialog.vue?vue&type=style&index=0&id=6479c16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479c16c",
  null
  
)

export default component.exports